import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-119d05e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reports list" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No reports found", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "for the selected month or search", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "date" }, "Date", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "ref" }, "Ref", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "type" }, "Type", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "address" }, "Address", -1))
const _hoisted_11 = {
  key: 0,
  class: "exported"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "report" }, "Report", -1))
const _hoisted_13 = {
  key: 1,
  class: "invoice"
}
const _hoisted_14 = {
  key: 2,
  class: "actions"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Actions", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Download Report PDFs"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1))
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1))
const _hoisted_25 = {
  key: 2,
  class: "text-left"
}
const _hoisted_26 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Actions"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "fas fa-lock"
}
const _hoisted_29 = {
  key: 1,
  class: "fas fa-unlock"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-clone" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["onClick", "disabled"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "D", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 3,
  class: "text-right"
}
const _hoisted_40 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Actions"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 4,
  class: "fee-totals list-inline"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "list-inline-item" }, "Monthly Total", -1))
const _hoisted_46 = { class: "list-inline-item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Reports:", -1))
const _hoisted_48 = { class: "list-inline-item" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fees:", -1))
const _hoisted_50 = ["disabled"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file" }, null, -1))
const _hoisted_52 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_53 = ["disabled"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file" }, null, -1))
const _hoisted_55 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}

import $ from 'jquery';
import 'bootstrap';
import { ref, computed, onMounted, inject, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { DepositoryTenancy, Dictionary, DictionaryReportType, Report, ReportTypeDictionary, Room, Section, Type } from '@/models';
import { ReportsState } from '@/store/reports/types';
import { ExportToCsv } from 'export-to-csv';
import moment from 'moment';
import sanitize from 'sanitize-filename';
import { checkitem } from '@/utilities';
import { useToast } from "vue-toastification";
import ProgressButton from "@/components/ProgressButton.vue";
import ReportPagination from "@/components/report/ReportPagination.vue";
import ReportMergeModal from "@/components/modals/ReportMergeModal.vue";
import DepositoryPropertyListModal from "@/components/modals/DepositoryPropertylistModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const toasted = useToast();

const actProperty: any = inject('actProperty');

const reportsState = computed(() => store.state.reports as ReportsState);

const dictionary = computed((): Dictionary => store.getters['dictionary/current']);
const hasBlockingRequests = computed(() => store.getters['app/hasBlockingRequests']);
const isAdministrator = computed(() => store.getters['auth/isAdministrator']);
const companyName = computed(() => store.getters['auth/companyName']);
const isCustomer = computed(() => store.getters['auth/isCustomer']);
const isDataentry = computed(() => store.getters['auth/isDataentry']);
const reports = computed((): Report[] => store.getters['reports/list']);
const statereport = computed(() => store.getters['reports/current']);
const monthlyFeesTotal = computed(() => store.getters['reports/monthlyFeesTotal']);

const downloadInvoiceAction = (report: Report): Promise<any> => {
  return store.dispatch('reports/downloadInvoice', report);
};

const generateReportPdfAction = (report: Report): Promise<any> => {
  return store.dispatch('reports/generateReportPdf', report);
};

const generateReportSummaryPdfAction = (report: Report): Promise<any> => {
  return store.dispatch('reports/generateReportSummaryPdf', report);
};

const downloadCSVAction = (payload: {month: string | null, search: string | null}): Promise<any> => {
  return store.dispatch('reports/downloadCSV', payload);
};

const downloadFeedbackCSVAction = (month: string | null): Promise<any> => {
  return store.dispatch('reports/downloadFeedbackCSV', month);
};

const setReportDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('reports/setReportDeep', payload);
}

const toggleReportLock = (report: Report): Promise<Report> => {
  return store.dispatch('reports/toggleReportLock', report);
};

const setCurrentPage = (page: number): Promise<any> => {
  return store.dispatch('reports/setCurrentPage', page);
};

const removeRequest = (id: string): void => {
  store.commit('app/removeRequest', id);
};

const setMergeSource = (report: Report): void => {
  store.commit('reports/setMergeSource', report);
};

const setReports = (reports: Report[]): void => {
  store.commit('reports/setReports', reports);
};

const downloadingCsv = ref(false);
const downloadingFeedbackCsv = ref(false);

// Methods
const isReportEditable = (report: Report) => {
  if (isAdministrator.value) return true;
    if (report && actProperty.isFactoryreport(report.type)) {
      if (
        report.companyName === companyName.value ||
        report.companyName.startsWith(companyName.value)
      ) {
        return true;
      }
    }
    return false;
};

const isCOSMActive = (report: Report) => {
  let result = true;
  if (report && report.customer && report.customer.reportsettings) {
    result =
      report &&
      report.customer &&
      report.customer.reportsettings.cosummaryactive;
  }
  return result;
}

const gotoReport = (report: Report) => {
  if (isDataentry.value)
      router.push({ name: "dereport", params: { id: report.id } });
    else router.push({ name: "report", params: { id: report.id } });
};

const doReportsPaging = (page: number): void => {
  setCurrentPage(page);
  const queryParams = { ...route.query };
  queryParams.page = page + ""; // hack to coerce to string
  if (isDataentry.value)
    router.push({ path: "dereports", query: queryParams });
  else router.push({ path: "reports", query: queryParams });
}

const downloadInvoice = (report: Report, requestId: string): void => {
  downloadInvoiceAction(report)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Invoice ${report.ref} PDF downloaded`);
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
}

const generateReportPdf = (report: Report, requestId: string): void => {
  generateReportPdfAction(report)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Report ${report.ref} PDF downloaded`);
      nextTick(() => {
        setReports([...reports.value]);
      });
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
}

const generateReportSummaryPdf = (report: Report, requestId: string): void => {
  generateReportSummaryPdfAction(report)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Report ${report.ref} Summary PDF downloaded`);
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
}

const toggleLock = (report: Report) => {
  toggleReportLock(report)
    .then((result: Report) => {
      // Update the current list of reports
      const reps = reports.value.map((x: Report) =>
        x.ref === result.ref ? result : x
      );
      setReports(reps);
      toasted.success(
        `${report.ref} ${result.locked ? "Locked" : "Unlocked"}`
      );
    })
    .catch((err: any) => actProperty.displayError(err));
  }

const downloadCSV = async () => {
  try {
      let search = route.query.search ? (route.query.search as string) : null;
      let month = route.query.month ? route.query.month : null;

      if (!month) {
        month = moment().format("YYYY-MM");
      }

      if (!month || typeof month !== "string") {
        toasted.error("CSV download failed. Please try again.");
      } else {
        downloadingCsv.value = true;
        downloadCSVAction({month: month, search: search})
          .then((results: any) => {
            let filename = "reports";
            if (route.query.search) {
              filename = sanitize(route.query.search as string);
            } else if (route.query.month) {
              filename = sanitize(route.query.month as string);
            }

            const csvExporter = new ExportToCsv({
              filename,
              useKeysAsHeaders: true,
            });

            results.forEach((r: any) => {
              if (dictionary.value && dictionary.value.reporttypes) {
                const reporttype = dictionary.value.reporttypes.find(
                  (t: DictionaryReportType) => t.slug === r.Type
                );
                if (reporttype) {
                  r.Type = reporttype.displayname;
                }
              }
            });

            if (isCustomer.value) {
              results
                .filter((r: any) => r.Type === "property visit")
                .forEach((r: any) => {
                  delete r.Company;
                  delete r.Branch;
                  delete r.Region;
                  delete r.Template;
                  delete r["Works/Purchase order Number"];
                  delete r["Fees + VAT"];
                  delete r["AC/Client Code"];
                  delete r["Nominal Code"];
                  delete r["Email"];
                });
            }
            csvExporter.generateCsv(results);

            toasted.success(
              "CSV downloaded. Please check your downloads folder."
            );
          })
          .finally(() => {
            downloadingCsv.value = false;
          })
          .catch((err: any) => actProperty.displayError(err));
      }
  } catch (err: any) {
    console.error(err);
    toasted.error("CSV download failed. Please try again.");
  }
};

const downloadFeedbackCSV = () => {
  try {
    let month = route.query.month ? route.query.month : null;

    if (!month) {
      month = moment().format("YYYY-MM");
    }

    if (!month || typeof month !== "string") {
      toasted.error("Feedback CSV download failed. Please try again.");
    } else {
      downloadingFeedbackCsv.value = true;
      downloadFeedbackCSVAction(month)
        .then((results: any) => {
          if (results && results.length) {
            let filename = "feedbackreports";
            if (route.query.search) {
              filename = sanitize(route.query.search as string);
            } else if (route.query.month) {
              filename = sanitize(route.query.month as string);
            }

            const csvExporter = new ExportToCsv({
              filename,
              useKeysAsHeaders: true,
            });

            csvExporter.generateCsv(results);

            toasted.success(
              "Feedback CSV downloaded. Please check your downloads folder."
            );
          } else {
            toasted.error("There are no reports in feedback list");
          }
        })
        .finally(() => {
          downloadingFeedbackCsv.value = false;
        })
        .catch((err: any) => actProperty.displayError(err));
    }
  } catch (err: any) {
    console.error(err);
    toasted.error("CSV download failed. Please try again.");
  }
}

const depositoryPropertyListModal = ref(null);
const showDepositoryPropertyListModal = (report: Report) => {
  const modalComponent = depositoryPropertyListModal.value;
  if (modalComponent && modalComponent.modalElement) {
    modalComponent.init(report)
    $(modalComponent.modalElement).show();
  }
};

const unlinkTenancy = () => {
  setReportDeep({
    path: "depositorytenancy",
    data: new DepositoryTenancy(),
  });
};

const roomswithdeductions = computed(() => {
  return statereport.value?.rooms?.filter((room: Room) => checkroom(room)) || [];
});

const checkroom = (room: Room) => {
  const result = room.sections.filter((section) => checksection(room, section));
  return result.length > 0;
};

const checksection = (room: Room, section: Section) => {
  const result = section.types.filter((type) => checktype(room, section, type));
  return result.length > 0;
};

const checktype = (room: Room, section: Section, type: Type) => {
  const result = type.items.filter((item) => checkitem(room, section, type, item));
  return result.length > 0;
};

const isCategoryFourRoom = (room: Room) => {
  const currentroomtype = room.type;
  const found = dictionary.value.rooms.findIndex(
    (dr) => dr.category === 4 && dr.slug === currentroomtype
  );
  return found >= 0;
};

const getDButtonVisible = (report: Report) => {
  return report.customer?.depository?.authToken && report.attachments?.report;
};

const onDepositorysubmitsuccess = (id: string) => {
  reports.value.forEach((report) => {
    if(report.id === id) {
      const datestamp = moment().utc().format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
      report.depositorydeductionssubmitdate = datestamp;
      report.attachments.reportuploaddate = datestamp;
    }
  });
};

onMounted(() => {
  // Equivalent to mounted() lifecycle hook in Vue 2
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!reports.value.length && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_openBlock(), _createElementBlock("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              (!isDataentry.value)
                ? (_openBlock(), _createElementBlock("th", _hoisted_11, "Exported"))
                : _createCommentVNode("", true),
              _hoisted_12,
              (!isDataentry.value)
                ? (_openBlock(), _createElementBlock("th", _hoisted_13, "Invoice"))
                : _createCommentVNode("", true),
              (isAdministrator.value || isCustomer.value || isDataentry.value)
                ? (_openBlock(), _createElementBlock("th", _hoisted_14, _hoisted_16))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value, (report, $index) => {
              return (_openBlock(), _createElementBlock("tr", { key: $index }, [
                _createElementVNode("td", null, _toDisplayString(_unref(actProperty).formatDateForDisplay(report.date)), 1),
                _createElementVNode("td", null, _toDisplayString(report.ref), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(actProperty).formatReportType(report.type, dictionary.value)), 1),
                _createElementVNode("td", {
                  innerHTML: _unref(actProperty).formatAddress(report.address)
                }, null, 8, _hoisted_17),
                (!isDataentry.value)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                      (report.exportedAt)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            innerHTML: _unref(actProperty).formatDatetimeForDisplay(report.exportedAt)
                          }, null, 8, _hoisted_19))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(ProgressButton, {
                      onClick: ($event: any) => (_unref(actProperty).copyDownloadButton(report, 'report')),
                      onDblclick: ($event: any) => (generateReportPdf(report, $event)),
                      class: "btn btn-outline-primary",
                      title: _unref(actProperty).formatReportType(report.type, dictionary.value)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 2
                    }, 1032, ["onClick", "onDblclick", "title"]),
                    (report.type == 'checkout')
                      ? (_openBlock(), _createBlock(ProgressButton, {
                          key: 0,
                          onClick: ($event: any) => (_unref(actProperty).copyDownloadButton(report, 'summary')),
                          onDblclick: ($event: any) => (generateReportSummaryPdf(report, $event)),
                          disabled: !isCOSMActive(report),
                          class: "btn btn-outline-primary",
                          title: "Check-Out Summary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 2
                        }, 1032, ["onClick", "onDblclick", "disabled"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (!isDataentry.value)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                      (report.totalFees())
                        ? (_openBlock(), _createBlock(ProgressButton, {
                            key: 0,
                            onClick: ($event: any) => (_unref(actProperty).copyDownloadButton(report, 'invoice')),
                            onDblclick: ($event: any) => (downloadInvoice(report, $event)),
                            class: "btn btn-outline-primary",
                            title: "Invoice"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24,
                              _createTextVNode(" " + _toDisplayString(_unref(actProperty).formatCurrency(`${report.totalFees()}`)), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "onDblclick"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (isAdministrator.value || isCustomer.value)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        (isReportEditable(report))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: _normalizeClass(["btn", {
                  'btn-outline-danger': !report.locked,
                  'btn-outline-success': report.locked,
                }]),
                              onClick: ($event: any) => (toggleLock(report))
                            }, [
                              (report.locked)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                                : (_openBlock(), _createElementBlock("i", _hoisted_29))
                            ], 10, _hoisted_27))
                          : _createCommentVNode("", true),
                        (!isCustomer.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-outline-primary",
                              "data-toggle": "modal",
                              "data-target": "#report-merge-modal",
                              title: "Merge",
                              onClick: ($event: any) => (setMergeSource(report))
                            }, _hoisted_32, 8, _hoisted_30))
                          : _createCommentVNode("", true),
                        (_openBlock(), _createElementBlock("button", {
                          class: _normalizeClass(["btn btn-outline-primary", {
                  'btn-outline-success':
                    report.depositorydeductionssubmitdate &&
                    report.attachments.reportuploaddate,
                  'amber-color':
                    ((!report.depositorydeductionssubmitdate &&
                    report.attachments.reportuploaddate) 
                    || (report.depositorydeductionssubmitdate &&
                    !report.attachments.reportuploaddate)),
                  'grey-color' : !report.customer.depository.authToken || !report.attachments.report,
                }]),
                          onClick: ($event: any) => (showDepositoryPropertyListModal(report)),
                          title: "Depositary",
                          disabled: !report.customer.depository.authToken || !report.attachments.report,
                          key: report.attachments.report
                        }, _hoisted_35, 10, _hoisted_33)),
                        (isReportEditable(report))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "btn btn-outline-primary",
                              onClick: ($event: any) => (gotoReport(report)),
                              title: "View"
                            }, _hoisted_38, 8, _hoisted_36))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (isDataentry.value)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-primary",
                          onClick: ($event: any) => (gotoReport(report)),
                          title: "View"
                        }, _hoisted_43, 8, _hoisted_41)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])),
    (isDataentry.value)
      ? (_openBlock(), _createBlock(ReportPagination, {
          key: 2,
          total: reports.value.length,
          current: reportsState.value.currentPage,
          limit: reportsState.value.pageLimit,
          onPageReports: doReportsPaging
        }, null, 8, ["total", "current", "limit"]))
      : (_openBlock(), _createBlock(ReportPagination, {
          key: 3,
          total: reportsState.value.monthlyReportCount,
          current: reportsState.value.currentPage,
          limit: reportsState.value.pageLimit,
          onPageReports: doReportsPaging
        }, null, 8, ["total", "current", "limit"])),
    (isAdministrator.value && reportsState.value.monthlyFeesTotal)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("li", _hoisted_46, [
            _hoisted_47,
            _createTextVNode(" " + _toDisplayString(reportsState.value.monthlyReportCount!.toLocaleString()), 1)
          ]),
          _createElementVNode("li", _hoisted_48, [
            _hoisted_49,
            _createTextVNode(" " + _toDisplayString(_unref(actProperty).formatCurrency(`${reportsState.value.monthlyFeesTotal}`)), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    ((isAdministrator.value || isCustomer.value) && reports.value.length)
      ? (_openBlock(), _createElementBlock("button", {
          key: 5,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadCSV())),
          class: "btn btn-outline-secondary",
          disabled: downloadingCsv.value
        }, [
          _hoisted_51,
          _createTextVNode(" Download CSV "),
          (downloadingCsv.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_52))
            : _createCommentVNode("", true)
        ], 8, _hoisted_50))
      : _createCommentVNode("", true),
    (isAdministrator.value && reports.value.length)
      ? (_openBlock(), _createElementBlock("button", {
          key: 6,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadFeedbackCSV())),
          class: "btn btn-outline-secondary",
          disabled: downloadingFeedbackCsv.value
        }, [
          _hoisted_54,
          _createTextVNode(" Download Feedback CSV "),
          (downloadingFeedbackCsv.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_55))
            : _createCommentVNode("", true)
        ], 8, _hoisted_53))
      : _createCommentVNode("", true),
    _createVNode(ReportMergeModal, { ref: "mergeReportModal" }, null, 512),
    _createVNode(DepositoryPropertyListModal, {
      ref_key: "depositoryPropertyListModal",
      ref: depositoryPropertyListModal,
      onDepositorysubmitsuccess: onDepositorysubmitsuccess
    }, null, 512)
  ]))
}
}

})